import { Button } from '@finn/design-system/atoms/button';
import { If } from '@finn/design-system/atoms/If';
import { Facebook } from '@finn/design-system/icons/facebook';
import { Link } from '@finn/design-system/icons/link';
import { SoicialLinkedin } from '@finn/design-system/icons/soicial-linkedin';
import { Twitter } from '@finn/design-system/icons/twitter';
import { useIntl } from '@finn/ui-utils';
import { useEffect, useState } from 'react';

import openShareWindow, {
  SharePlatform,
} from '../SocialSharing/openShareWindow';
import { copyCurrentLink } from '../SocialSharing/SocialSharing';
import { GuideItem } from './GuideItem';

const socialItems = [
  {
    platform: SharePlatform.FACEBOOK,
    icon: <Facebook className="!h-4 !w-[9px]" />,
  },
  {
    platform: SharePlatform.TWITTER,
    icon: <Twitter />,
  },
  {
    platform: SharePlatform.LINKEDIN,
    icon: <SoicialLinkedin />,
  },
];

export const Guide = ({
  reading_time,
  date,
}: {
  reading_time?: string;
  date?: string;
}) => {
  const intl = useIntl();
  const [showCopySuccess, setShowCopySuccess] = useState(false);

  useEffect(() => {
    if (showCopySuccess) {
      const timer = setTimeout(() => {
        setShowCopySuccess(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showCopySuccess, setShowCopySuccess]);

  return (
    <div className="grid gap-4 [grid-template-columns:repeat(3,100px)] md:[grid-template-columns:repeat(3,164px)]">
      <If condition={Boolean(reading_time)}>
        <GuideItem
          title={intl.formatMessage('general.guideReadTime')}
          description={reading_time}
        />
      </If>
      <If condition={Boolean(date)}>
        <GuideItem
          title={intl.formatMessage('general.guideDate')}
          description={date}
        />
      </If>
      <GuideItem title={intl.formatMessage('general.guideShare')}>
        <div className="flex h-3 items-center gap-4">
          {socialItems.map((item) => (
            <Button
              key={item.platform}
              size="sm"
              variant="ghost"
              className="!size-6 rounded-full p-0"
              onClick={() => openShareWindow(item.platform)}
            >
              {item.icon}
            </Button>
          ))}
          <Button
            size="sm"
            variant="ghost"
            className="!size-6 rounded-full p-0"
            onClick={() => {
              copyCurrentLink();
              setShowCopySuccess(true);
            }}
          >
            <Link />
          </Button>
          <div className="relative">
            {showCopySuccess ? (
              <span className="absolute -left-5 top-2.5 block rounded-sm bg-black px-3 text-snow">
                {intl.formatMessage('general.guideLinkCopied')}
              </span>
            ) : null}
          </div>
        </div>
      </GuideItem>
    </div>
  );
};
